import { Page } from 'lemans-brandsites-common/components/Page';
import { Spinner } from 'lemans-brandsites-common/components/Spinner';
import { pageRestHandleSideEffects } from 'lemans-brandsites-common/libs/apiHandleSideEffects';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { brandName } from 'theme/libs/config';
import { FourOhFour } from '../FourOhFour';
import './TermsAndConditions.styles.less';
import { ITermsAndConditionsProps } from "./TermsAndConditions.types";

export const TermsAndConditions = (props: ITermsAndConditionsProps) => {
    const [content, setContent] = useState<string>('');
    const [fourOhFour, isLoading, data] = pageRestHandleSideEffects('terms-and-conditions');
    const [title, setTitle] = useState<string>('');

    useEffect(() => {
        setContent(data?.content.rendered ? data?.content.rendered : '');
        setTitle(data?.title.rendered ? data?.title.rendered : '');
    }, [data]);

    return <>
        {fourOhFour && <FourOhFour />}
        {isLoading && <Spinner defaultIndicator={true} size="large" />}
        {!isLoading && !fourOhFour && data &&
            <Page className="Terms And Conditions" title={`${brandName} - ${title}`}>
                <div className="container">
                    <h1>{title}</h1>
                </div>
                <div className="container" dangerouslySetInnerHTML={{ __html: content }}/>
            </Page>
        }
    </>
}
